export default __webpack_public_path__ + "static/media/easyIcon.1b335699.svg";